var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.needsToShowTimer && _vm.timerStatus)?_c('div',{staticClass:"re-cart-timer"},[_c('re-toast-alert',{staticClass:"cart-timer",attrs:{"no-icon":true,"type":_vm.timerWarningType,"containerClass":"cart-timer"}},[_vm._v(_vm._s(_vm.timerStatus))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }